// #region IMPORTS
import { MdExitToApp as ExitToApp } from 'react-icons/md';
import { MdHowToReg as HowToReg } from 'react-icons/md';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppAuth } from '../Auth/authAdapter';
// #endregion

// #region COMPONENT
/**
 * @returns {JSX.Element} The connected user name and the sign out button
 */
const AuthButton = () => {
  // #region INITIALIZATION
  // Hooks
  const { user } = useAppAuth();
  const [t] = useTranslation('Navbar');
  const { logout } = useAppAuth();
  // #endregion

  // #region EVENT
  // Manage the user deconnexion
  const handleDisconnect = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };
  // #endregion

  // #region INTERFACE
  return (
    <>
      <div className="AZmedNavbar-sectionDesktop">
        <button aria-haspopup="true" className="AZmedNavbar-navButton">
          <HowToReg style={{ marginRight: '5px' }} />
          {user ? `${user.given_name} ${user.family_name}` : null}
        </button>
      </div>
      <button className="AZmedNavbar-navButton" onClick={handleDisconnect}>
        <ExitToApp style={{ marginRight: '5px' }} />
        <div className="AZmedNavbar-sectionDesktop">{t('Sign out')}</div>
      </button>
    </>
  );
  // #endregion
};
// #endregion

export { AuthButton };
